package chat.amp.tim

import io.ktor.resources.*
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import net.folivo.trixnity.core.HttpMethod
import net.folivo.trixnity.core.HttpMethodType.POST
import net.folivo.trixnity.core.MatrixEndpoint
import net.folivo.trixnity.core.model.UserId
import net.folivo.trixnity.core.model.events.m.room.EncryptedFile

@Serializable
@Resource("/_matrix/media_proxy/unstable/scan_encrypted")
@HttpMethod(POST)
data class ScanEncryptedMedia(
    @SerialName("user_id") val asUserId: UserId? = null
) : MatrixEndpoint<ScanEncryptedMedia.Request, ScanEncryptedMedia.Response> {

    @Serializable
    data class Request(
        @SerialName("file") val file: EncryptedFile?,
    ) {
    }

    @Serializable
    data class Response(
        @SerialName("clean") val clean: Boolean,
        @SerialName("info") val info: String
    )
}
